import TabsInDrawer from './TabsInDrawer'

export default TabsInDrawer
